import { useState } from "react";
import { isTextEllipsed } from "../../../utils/general_utils";
import { Stack, Tooltip } from "@mui/material";
import { EllipsisTooltip } from "../../ui/CustomTooltip";
import { DotIcon, UpdateIcon } from "../../images";
import { ColumnList } from "./columnList";
import { AccountListItem } from "../../../types";
import { BuyerJourney } from "../../ui";

type Props = {
  column: ColumnList;
  row: AccountListItem;
  cellIndex: number;
};

export const CellBody = ({ row, column, cellIndex }: Props) => {
  const [showTableTooltip, setShowTableTooltip] = useState(false);

  const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.currentTarget;
    setShowTableTooltip(isTextEllipsed(target));
  };

  if (column.key === "buyer_journey")
    return (
      <Stack
        sx={{
          alignItems: "flex-start",
          paddingLeft: "8px",
        }}
      >
        <BuyerJourney data={row[column.key]} />
      </Stack>
    );

  return (
    <span
      style={{
        display: "flex",
        justifyContent: `${
          (row.is_new || row.status === "updated") && cellIndex === 1
            ? "space-between"
            : column.flexAlign
        }`,
        gap: "16px",
        paddingRight: `${
          (row.is_new || row.status === "updated") && cellIndex === 1
            ? "0"
            : "8px"
        }`,
      }}
    >
      <Tooltip
        title={showTableTooltip ? row[column.key]?.toString() || "" : ""}
        placement="bottom"
        arrow
        sx={{
          background: "#596177E5",
          fontSize: "12px",
          lineHeight: "16px",
          fontWeight: 400,
          textAlign: column.textAlign,
        }}
      >
        <span
          onMouseEnter={handleMouseEnter}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
          }}
        >
          {row[column.key] === null ? "--" : row[column.key]}
        </span>
      </Tooltip>
      {cellIndex === 1 && row.is_new && row.status !== "updated" && (
        <Stack
          minWidth="24px"
          minHeight="24px"
          alignItems="center"
          justifyContent="center"
        >
          <EllipsisTooltip tooltip="New account">
            <DotIcon />
          </EllipsisTooltip>
        </Stack>
      )}

      {cellIndex === 1 && row.status === "updated" && (
        <Stack
          minWidth="24px"
          minHeight="24px"
          alignItems="center"
          justifyContent="center"
        >
          <EllipsisTooltip tooltip="Updated account">
            <UpdateIcon color="#1C3C6C" />
          </EllipsisTooltip>
        </Stack>
      )}
    </span>
  );
};
